"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlight = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const Text_1 = require("../Text");
exports.Highlight = react_1.default.memo(({ word, substring }) => {
    const index = word.toLowerCase().indexOf(substring.toLowerCase());
    const before = word.substr(0, index);
    const after = word.substr(index + substring.length, word.length);
    const caseTransformedSubstring = substring
        .split("")
        .map((char, index) => char.toUpperCase() === word[index]
        ? char.toUpperCase()
        : char.toLowerCase());
    return (react_1.default.createElement(HighlightedText, { noTitle: true },
        react_1.default.createElement(Highlighted, null, before),
        react_1.default.createElement(Rest, null, caseTransformedSubstring),
        react_1.default.createElement(Highlighted, null, after)));
});
const HighlightedText = (0, styled_components_1.styled)(Text_1.Text) `
  display: block;
  flex-grow: 1;
  width: 0;
  &:hover {
    cursor: pointer;
  }
`;
const Highlighted = styled_components_1.styled.span `
  opacity: 0.5;
`;
const Rest = styled_components_1.styled.span `
  opacity: 1;
`;
//# sourceMappingURL=index.js.map